export default "__VITE_ASSET__325f3193__"